import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Product Name',
    value: 'productName',
  },
  {
    label: 'Dpp ID',
    value: 'id',
  },
  {
    label: 'SKU Item',
    value: 'categoryItem',
  },
  {
    label: 'Dimension',
    value: 'dimension',
  },
  {
    label: 'Weight',
    value: 'weight',
  },
  {
    label: 'Product Imgae',
    // value: 'POE_null',
    value: 'ProductImgae',
  },
  {
    label: 'View',
    value: 'viewddp',
  },
  {
    action: ['edit']
  },

]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
